import React from 'react';
import Checkbox from '@components/v2/Checkbox';
import './CheckboxCardList.scss';
function CheckboxCardList({ items, onChange, className = '', cardClassName = '', idPrefix = 'checkbox-card' }) {
    return (React.createElement("div", { className: `checkbox-card-list ${className}` }, items.map((item) => (React.createElement("div", { key: item.id, role: "button", tabIndex: 0, className: `checkbox-card ${item.checked ? 'checkbox-card--checked' : ''} ${cardClassName}`, onClick: () => onChange(item.id, !item.checked), onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onChange(item.id, !item.checked);
            }
        }, "aria-label": item.title },
        React.createElement(Checkbox, { id: `${idPrefix}-${item.id}`, checked: item.checked, onChange: (checked) => onChange(item.id, checked), onClick: (e) => e.stopPropagation(), label: item.title, description: item.description }))))));
}
export default CheckboxCardList;
